export default __webpack_public_path__ + "static/media/profilepage-cancelEditInfo.12545d98.svg";